import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const HomeSectionEducation = props => (
  <div className='check-list color-green'>
    <div className='check-list-item'>
      <div className='check-list-item-progress'>
        <div
          className='check-list-item-index check-list-item-index--enormous'>
          <FontAwesomeIcon icon={['fas', 'graduation-cap']}/>
        </div>
        <div className='check-list-item-sep'>
        </div>
      </div>
      <div className='check-list-item-body'>
        <h2 className='uppercase'>Education</h2>
        <p/>
      </div>
    </div>
    <div className='check-list-item'>
      <div className='check-list-item-progress'>
        <div className='check-list-item-index'>
        </div>
        <div className='check-list-item-sep'>
        </div>
      </div>
      <div className='check-list-item-body'>
        <p className='title'>
          <b>Kursk State University</b> <span><span
          className='no-mobile'>/ </span>2006 – 2011</span>
        </p>
        <p>
          <b>Mathematician and software developer course</b>: got a specialist degree at KSU in computer science and math. Got all excellent marks, was one of the best students at my group of students.
        </p>
      </div>
    </div>
    <div className='check-list-item print-avoid-break-inside'>
      <div className='check-list-item-progress'>
        <div className='check-list-item-index'>
        </div>
        <div className='check-list-item-sep'>
        </div>
      </div>
      <div className='check-list-item-body'>
        <p className='title'>
          <b>Gymnasium #25 at Kursk, Russia</b> <span><span
          className='no-mobile'>/ </span>1999 – 2006</span>
        </p>
        <p>
          <b>Student</b>. Studying here helped me get a basic knowledge of programming, math and analysis abilities. I took part at several contests in math and programming taking the winning places.
        </p>
      </div>
    </div>
  </div>
);
